import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunk для загрузки дел
export const fetchCases = createAsyncThunk(
  'cases/fetchCases',
  async (
    { limitForView, append = false, updateExisting = false },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/get-all-cases', {
        params: { limitForView },
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!Array.isArray(response.data.cases)) {
        return rejectWithValue(response.data.message || 'Неверный формат данных от сервера');
      }

      return {
        cases: response.data.cases,
        totalCount: response.data.totalCount || 0,
        append,
        updateExisting,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Ошибка сервера');
    }
  }
);

const casesSlice = createSlice({
  name: 'cases',
  initialState: {
    list: [],
    loading: false,
    error: null,
    totalCount: 0,
    lastUpdateTime: null,
    scrollPosition: 0,
    limitForView: 40,
    scrollPosition: 0,
  },
  reducers: {
    setScrollPosition(state, action) {
      state.scrollPosition = action.payload;
    },
    clearCases(state) {
      state.list = [];
      state.loading = false;
      state.error = null;
      state.lastUpdateTime = null;
      state.totalCount = 0;
      state.limitForView = 10;
    },
    setLimitForView(state, action) {
      state.limitForView = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCases.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCases.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.totalCount = action.payload.totalCount;
        state.lastUpdateTime = new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

        const newCases = action.payload.cases;
        const { append, updateExisting } = action.payload;

        if (append) {
          // Добавление в конец без дубликатов
          const existingIds = new Set(state.list.map(item => item.id));
          const filtered = newCases.filter(item => !existingIds.has(item.id));
          state.list = [...state.list, ...filtered];
        } else if (updateExisting) {
          // Обновляем существующие, добавляем новые
          const casesMap = new Map(state.list.map(item => [item.id, item]));
          for (const newItem of newCases) {
            const existing = casesMap.get(newItem.id) || {};
            casesMap.set(newItem.id, { ...existing, ...newItem });
          }
          state.list = Array.from(casesMap.values());
        } else {
          // Полная перезапись списка
          state.list = newCases;
        }
      })
      .addCase(fetchCases.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Ошибка при загрузке';
      });
  },
});

export const { setScrollPosition, clearCases, setLimitForView } = casesSlice.actions;
export default casesSlice.reducer;
